import { get } from 'lodash';

export const getLocale = (state) => get(state, 'locale.current');
export const getQueryLocale = (state) => get(state, 'locale.query');
